import { sendAuthorizedRequest, HttpMethod } from './authWrapper';
import { AuthManagementEndpointBaseUrl } from '../properties/appProperties';

export function getUserPermissions(host: string) {
    let authManagementEndpoint = host + AuthManagementEndpointBaseUrl;
   return sendAuthorizedRequest(HttpMethod.GET, authManagementEndpoint);
 }